<section id="logo" style="background-image: url('assets/background.png');">
    <div class="container-fluid">
        <div class="row justify-content-center align-items-center">
            <div class="offset-1 col-10">
                <img src="assets/logos/alarbuli.svg">
            </div>
        </div>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fill-opacity="1" d="M0,64L60,74.7C120,85,240,107,360,144C480,181,600,235,720,224C840,213,960,139,1080,112C1200,85,1320,107,1380,117.3L1440,128L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path></svg>
</section>

<!--
<section id="products">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 d-flex justify-content-center my-4">
                <img src="assets/citrics_slices/lemon_slice.svg">
            </div>
            <div class="col-lg-4 mt-3 d-flex justify-content-lg-start justify-content-center my-4">
                <img src="assets/citrics_slices/lime_slice.svg">
            </div>
            <div class="col-lg-4 d-flex justify-content-lg-end justify-content-center my-4">
                <img src="assets/citrics_slices/orange_slice.svg">
            </div>
            <div class="col-lg-4 d-flex justify-content-center my-4">
                <img src="assets/citrics_slices/tangerine_slice.svg">
            </div>
            <div class="col-lg-4 mt-3 d-flex justify-content-lg-start justify-content-center my-4">
                <img src="assets/citrics_slices/grapefruit_slice.svg">
            </div>
            <div class="col-lg-4 d-flex justify-content-lg-end justify-content-center my-4">
                <img src="assets/citrics_slices/pomegranate_slice.svg">
            </div>
        </div>
    </div>
</section>
-->
<section id="certifications">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 d-flex justify-content-lg-end justify-content-center my-4">
                <img src="assets/logos/sohiscert.svg">
            </div>
            <div class="col-lg-4 d-flex justify-content-center my-4">
                <img src="assets/logos/eco.svg">
            </div>
            <div class="col-lg-4 mt-3 d-flex justify-content-lg-start justify-content-center my-4">
                <img src="assets/logos/caae.svg">
            </div>
            <div class="offset-2 col-lg-4 col-8 d-flex justify-content-center my-4">
                <img src="assets/logos/globalgap.svg">
            </div>
            <div class="col-lg-4 d-flex justify-content-center my-4">
                <img src="assets/logos/ifs.svg">
            </div>
        </div>
    </div>
</section>

<section id="advertising">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 d-flex justify-content-lg-end justify-content-center my-4">
                <a class="d-flex flex-column justify-content-center" [routerLink] = "['advertising']">
                    <img src="assets/advertising/adv2.svg">
                </a>
            </div>
            <div class="col-lg-4 d-flex justify-content-center my-4">
                <a class="d-flex flex-column justify-content-center" [routerLink] = "['advertising']">
                    <img src="assets/advertising/adv3.svg">
                </a>
            </div>
            <div class="col-lg-4 d-flex justify-content-lg-start justify-content-center my-4">
                <a class="d-flex flex-column justify-content-center" [routerLink] = "['advertising']">
                    <img src="assets/advertising/adv4.svg">
                </a>
            </div>
        </div>
    </div>
</section>

<section id="end" style="background-image: url('assets/background.png');">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fill-opacity="1" d="M0,64L60,74.7C120,85,240,107,360,144C480,181,600,235,720,224C840,213,960,139,1080,112C1200,85,1320,107,1380,117.3L1440,128L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path></svg>
</section>